import React from 'react';
import { render } from 'react-dom';
import App from './containers/app';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from './utils/configure-store';
import './style/globals/resets.css';

const store = configureStore();

render((
  <Provider store={ store }>
    <Router>
      <App/>
    </Router>
  </Provider>
), document.getElementById('app'));




// WEBPACK FOOTER //
// ./client/src/index.jsx